export const REDACTED_VALUE = '[Filtered]'

const buildParamPattern = (paramNames: readonly string[]) =>
    new RegExp(`([?&](?:${paramNames.join('|')})=)[^&#"\\s]*`, 'g')

export const redactQueryParams = (text: string, paramNames: readonly string[]): string =>
    text.replace(buildParamPattern(paramNames), `$1${REDACTED_VALUE}`)

// A JSON round trip reaches every URL in a nested payload (request, breadcrumbs, spans) without
// knowing its shape. Only use it on plain JSON data, such as a Sentry event before it is sent.
export const redactQueryParamsDeep = <T>(value: T, paramNames: readonly string[]): T =>
    JSON.parse(redactQueryParams(JSON.stringify(value), paramNames)) as T
